import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { NestedProductDto } from '../types/dtos';

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.mutation<void, { id: string; payload: Partial<NestedProductDto> }>({
        query: ({ id, payload }) => ({
            url: `${APP_ENDPOINTS.NESTED_PRODUCT}/${id}`,
            method: 'PATCH',
            body: payload,
        }),
        invalidatesTags: [
            { type: 'nested-products', id: 'GET' },
            { type: 'nested-products-with-join', id: 'GET-JOIN' },
            { type: 'nested-product', id: 'GET-ID' },
        ],
    });
